<!-- <div class="modal-header" style="padding: 10px !important ;border-radius: 5px;">
  <div class="main">
    <div>
      <h4> Create Network</h4>
    </div>
    <div>
      <button type="button" class="close pull-right close-model" aria-label="Close" (click)="modelhide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</div> -->

<div class="modal-content">
  <div class="common-header-flex">
    <div>Create Network</div>
    <button>
      <span (click)="modelhide()" class="common-close">&times;</span>
    </button>
  </div>
  <hr style="margin: 0px !important; padding: 0px !important">
  <div class="modal-body">
    <div [formGroup]="networkForm">
      <div class="row ">
        <div class="col-md-8 discol">
          <div class="form-group mt-10">
            <label for="networkName " class="required">Network Name</label>
            <div>
              <input maxlength="31" type="text" class="form-control input-sm" formControlName="networkName"
                placeholder="Please enter a network name" trim="blur" />
              <div
                *ngIf="(submit && f.networkName.invalid) || (f.networkName.invalid && (f.networkName.dirty || f.networkName.touched))"
                class="error-msg">
                <div class="red" *ngIf="f.networkName.errors?.pattern">Name must contain alphabet only</div>
                <div class="red" *ngIf="f.networkName.errors?.required">Network name is required</div>
                <div class="red" *ngIf="f.networkName.errors?.minLetters">Minimum 5 chars required</div>
                <div class="red" *ngIf="f.networkName.errors?.maxLetters">Maximum 30 chars allowed</div>
              </div>
            </div>
          </div>
          <div>
            <div class="mt-10">
              <label for="">Add Connection</label>
            </div>
            <div>

              <ng-select class="gs-conn-select" [multiple]="true" [items]="conditionList" [hideSelected]="false" [(ngModel)]="conditionSelectedItems"
                name="licenseAuthorityId" bindValue="userId" [closeOnSelect]="false" bindLabel="userName"
                formControlName="addconnection" placeholder="Add Connection" required>
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <div class="ng-select-checkbox-label">
                    <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                    <img *ngIf="item.photo" class="img-show-hides" [src]="url+item.photo" style="margin-left: 8px;">
                    <div *ngIf="!item?.photo" class="circleimg-show-hide"
                      [style.background-color]="getColorName(item?.firstName, item.lastName)" style="margin-left: 8px;">
                      <div class="circle-text" [style.color]="getTextColor(item?.firstName, item?.lastName)">{{ getInitialName(item?.firstName, item.lastName) }}</div>
                    </div>
                    <span class="ng-select-checkbox-text add-connection-name" [attr.title]="item.userName">{{item.userName}}</span>
                  </div>
                </ng-template>
                <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                  <div class="selected-item" [attr.title]="item.userName">
                    <span class="ng-value-clear remove-icon" (click)="clear(item)">
                      ✕
                    </span>
                    <span class="ng-value-label">{{ item.userName }}</span>
                  </div>
                </ng-template>
              </ng-select>

            </div>
            <div *ngIf="(submit && f.addconnection.invalid) ||
            (f.addconnection.invalid &&
              (f.addconnection.dirty ||
                f.addconnection.touched))">

              <div *ngIf="f.addconnection.errors" style="color:#c3002f;float: right;">
                At least one connection is required
              </div>
            </div>
          </div>
          <div>
            <div class="mt-10">
              <label for="">Network Logo</label>
            </div>
            <div>
              <input type="file" class="form-control input-sm" accept=".jpg, .jpeg, .png" #myFileInput
                (change)="fileChangeEvent($event, template)"   (click)="resetFileId()" />

            </div>
          </div>


          <div>

            <div class="mt-10">
              <label for="">Description</label>
            </div>
            <div>
              <div class="form-group R-summary">
                <textarea class="form-control input-sm" placeholder="Description" [ngxSummernote]="config"
                  formControlName="description" name="" id="" rows="3" ></textarea>
                <div class="error-msg" *ngIf="f.description.invalid ">
                  <div *ngIf="f.description.errors.maxchar">
                    {{FORMERROR.ABOUT_YOURSELF_MAX}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div>
            <label for="">How it works?</label>
          </div>
          <div>
            <p>
              You can create personal Networks and add your Connections to
              specific Networks.
            </p>
            <p>
              You can connect, share and collaborate with your connections in
              specific Network as a group.
            </p>
          </div>
          <div>
            <ng-icon name="customNetworkIllustration"></ng-icon>

            <!-- <img src="assets/icon/img.png" alt="" srcset="" /> -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button type="button" class="btn btn-default m-r-6" (click)="modelhide()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary m-r-20" [disabled]="!networkForm.valid" (click)="save()">
          Create
        </button>
      </div>
    </div>
  </div>

</div>




<ng-template #template>
  <div class="modal-content">
    <div class="common-header-flex">
      <div>Network Logo</div>
      <button>
        <span (click)="closePhoto()" class="common-close">&times;</span>
      </button>
    </div>
    <hr style="margin: 0px !important; padding: 0px !important">
    <div class="modal-body">
      <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" format="jpeg"
        (imageCropped)="imageCropped($event)"></image-cropper>
    </div>

    <div class="custom-panel-footer">
      <div class="panel-footer">
        <div class="footer-flex">
          <button class="btn btn-default" (click)="closePhoto()">Cancel</button>
          <button class="btn btn-primary" (click)="imageLoaded()">Apply</button>
        </div>
      </div>
    </div>

  </div>
</ng-template>
